import React from 'react';

export const B = ({ x, y, w, h, label, sub, color, r = 8 }) => (
  <g>
    <rect x={x} y={y} width={w} height={h} rx={r} fill={color} opacity={0.1} stroke={color} strokeWidth={1.5} />
    {label.split('\n').map((l, i) => (
      <text key={i} x={x + w / 2} y={y + (sub ? 16 : h / 2 + 5) + i * 14} textAnchor="middle" fontSize="11" fontWeight="600" fill={color}>{l}</text>
    ))}
    {sub && <text x={x + w / 2} y={y + h - 6} textAnchor="middle" fontSize="8" fill="#64748b">{sub}</text>}
  </g>
);

export const D = ({ x, y, s, label, color }) => {
  const cx = x, cy = y;
  return (
    <g>
      <polygon points={`${cx},${cy - s} ${cx + s},${cy} ${cx},${cy + s} ${cx - s},${cy}`} fill={color} opacity={0.1} stroke={color} strokeWidth={1.5} />
      {label.split('\n').map((l, i) => (
        <text key={i} x={cx} y={cy - 4 + i * 12} textAnchor="middle" fontSize="9.5" fontWeight="600" fill={color}>{l}</text>
      ))}
    </g>
  );
};

export const Arr = ({ x1, y1, x2, y2, color = '#475569', dashed }) => {
  const dx = x2 - x1, dy = y2 - y1;
  const len = Math.sqrt(dx * dx + dy * dy);
  if (len === 0) return null;
  const ux = dx / len, uy = dy / len;
  const ax = x2 - ux * 6, ay = y2 - uy * 6;
  return (
    <g>
      <line x1={x1} y1={y1} x2={ax} y2={ay} stroke={color} strokeWidth={1.3} opacity={0.5} strokeDasharray={dashed ? '4,3' : 'none'} />
      <polygon points={`${x2},${y2} ${ax - uy * 3.5},${ay + ux * 3.5} ${ax + uy * 3.5},${ay - ux * 3.5}`} fill={color} opacity={0.6} />
    </g>
  );
};

export const Lbl = ({ x, y, text, color = '#16a34a', size = 8 }) => (
  <text x={x} y={y} fontSize={size} fill={color} fontWeight="600">{text}</text>
);

export const Lane = ({ x, y, w, h, title, color }) => (
  <g>
    <rect x={x} y={y} width={w} height={h} rx={6} fill={color} opacity={0.04} stroke={color} strokeWidth={0.8} strokeDasharray="6,4" />
    <text x={x + 10} y={y + 16} fontSize="10" fontWeight="700" fill={color} opacity={0.7}>{title}</text>
  </g>
);
